import { Div, Collection, CollectionPrinter } from "@tblabs/truffle";
import { appendable } from "@tblabs/truffle/Core/appendable";
import { CollectionItemPrinter } from "../../Components/Utils/CollectionItemPrinter";


export class CollectionItemsPrinter<T> extends Div
{
    constructor(collection: Collection<T>, title: (item: T) => appendable[], content: (item: T) => appendable[])
    {
        super();

        this.Append(
            new CollectionPrinter(collection, x => new CollectionItemPrinter(x, collection, title(x))
                .AddContent(...content(x)))
        );
    }
}
